<h3>Seção de Live</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="live-section">
    <div class="live-item p-card">
      <div class="live-content">
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="title"
            id="title"
            name="title"
          />
          <label for="title">Título *</label>
        </span>
        <span class="p-float-label">
          <input
            type="url"
            pInputText
            formControlName="link"
            id="link"
            name="link"
          />
          <label for="link">Link *</label>
        </span>
        <span class="p-input-checkbox">
          <p-checkbox
            formControlName="active"
            [binary]="true"
            inputId="active"
          />
          <label for="active">Ativo</label>
        </span>
      </div>
    </div>
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/mens/home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
